module.exports = require("i18next-localstorage-backend");